export const DEFAULT_DOCUMENT_TITLE = 'Оценить квартиру онлайн калькулятор недвижимости - Циан';

export enum EPageTypes {
  // Обычный отчет об оценке квартиры (пользователь агент)
  EstateCalculatorB2B = 'EstateCalculatorB2B',
  // Страница готового (статического) отчета об оценке квартиры
  EstateCalculatorB2BPreview = 'EstateCalculatorB2BPreview',
  // Обычный отчет об оценке квартиры (пользователь поискун)
  EstateCalculator = 'EstateCalculator',
  // Мой дом квартира вторичка
  MyHomeDetailed = 'MyHomeDetailed',
  // Обычный отчет об оценке загородки (дом/участков)
  CalculatorSuburban = 'CalculatorSuburban',
  // Мой дом загородка (дом/участок)
  MyHomeSuburbanDetailed = 'MyHomeSuburbanDetailed',
}

export const FLAT_PATH = '/kalkulator-nedvizhimosti/';
export const SUBURBAN_PATH = '/kalkulator-nedvizhimosti-suburban/';
